import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  select(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.url

    const form = document.createElement('form')
    form.method = 'POST'
    form.action = url

    // Add CSRF token
    const csrfToken = document.querySelector('[name="csrf-token"]').content
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    document.body.appendChild(form)
    form.submit()
  }
}
